/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online syllable counter. Paste any text to count syllables, words and characters — line by line. Great for poetry, haiku and songwriting.`)
};

const es_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas online gratuito. Pega cualquier texto para contar sílabas, palabras y caracteres — línea por línea. Ideal para poesía, haikus y composición de canciones.`)
};

const de_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Silbenzähler. Füge beliebigen Text ein, um Silben, Wörter und Zeichen zu zählen — Zeile für Zeile. Ideal für Gedichte, Haikus und Songtexte.`)
};

const nl_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online lettergreepteller. Plak elke tekst om lettergrepen, woorden en tekens te tellen — regel voor regel. Ideaal voor poëzie, haiku's en songteksten.`)
};

const fr_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de syllabes en ligne gratuit. Collez n'importe quel texte pour compter les syllabes, les mots et les caractères — ligne par ligne. Idéal pour la poésie, les haïkus et l'écriture de chansons.`)
};

const it_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di sillabe online gratuito. Incolla qualsiasi testo per contare sillabe, parole e caratteri — riga per riga. Ideale per poesia, haiku e scrittura di canzoni.`)
};

const pt_br2_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas online gratuito. Cole qualquer texto para contar sílabas, palavras e caracteres — linha por linha. Ótimo para poesia, haiku e composição de letras.`)
};

const pt_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de sílabas online gratuito. Cole qualquer texto para contar sílabas, palavras e caracteres — linha a linha. Ótimo para poesia, haiku e composição de letras.`)
};

const ja_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン音節カウンター。テキストを貼り付けるだけで、音節数・単語数・文字数を行ごとにカウントできます。詩や俳句、作詞にも最適。`)
};

const zh_syl_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的在线音节计数器。粘贴任意文本即可逐行统计音节数、单词数和字符数，非常适合诗歌、俳句和歌词创作。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const syl_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.syl_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("syl_hub_meta_description", locale)
	if (locale === "en") return en_syl_hub_meta_description(inputs)
	if (locale === "es") return es_syl_hub_meta_description(inputs)
	if (locale === "de") return de_syl_hub_meta_description(inputs)
	if (locale === "nl") return nl_syl_hub_meta_description(inputs)
	if (locale === "fr") return fr_syl_hub_meta_description(inputs)
	if (locale === "it") return it_syl_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_syl_hub_meta_description(inputs)
	if (locale === "pt") return pt_syl_hub_meta_description(inputs)
	if (locale === "ja") return ja_syl_hub_meta_description(inputs)
	return zh_syl_hub_meta_description(inputs)
};